import { StyleSheet } from 'react-native';

export const createStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
    },
    centerContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    header: {
      padding: 20,
      borderBottomWidth: 1,
    },
    title: {
      fontSize: 24,
      fontWeight: 'bold',
      marginBottom: 5,
    },
    subtitle: {
      fontSize: 16,
    },
    championBanner: {
      marginTop: 10,
      paddingHorizontal: 10,
      paddingVertical: 6,
      borderRadius: 6,
      flexDirection: 'row',
      alignItems: 'center',
      borderWidth: 1,
      borderColor: 'rgba(184, 134, 11, 0.3)',
      backgroundColor: 'rgba(184, 134, 11, 0.08)',
      alignSelf: 'flex-start',
    },
    championLabel: {
      fontSize: 11,
      fontWeight: '600',
      color: '#B8860B',
      letterSpacing: 0.3,
    },
    championName: {
      fontSize: 14,
      fontWeight: '600',
    },
    roleBadge: {
      marginTop: 10,
      paddingHorizontal: 12,
      paddingVertical: 6,
      borderRadius: 12,
      alignSelf: 'flex-start',
      flexDirection: 'row',
      alignItems: 'center',
    },
    roleBadgeText: {
      fontSize: 12,
      fontWeight: '600',
      color: '#fff',
    },

    // Tabs
    tabBar: {
      flexDirection: 'row',
      borderBottomWidth: 1,
    },
    tabButton: {
      flex: 1,
      paddingVertical: 15,
      alignItems: 'center',
      position: 'relative',
    },
    tabButtonActive: {},
    tabButtonText: {
      fontSize: 14,
      fontWeight: '600',
    },
    tabIndicator: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: 3,
    },

    // Content
    content: {
      flex: 1,
    },
    contentContainer: {
      paddingBottom: 20,
    },

    // Round Robin Standings
    standingsSection: {
      margin: 15,
      padding: 15,
      borderRadius: 12,
      borderWidth: 1,
    },
    standingsTitle: {
      fontSize: 20,
      fontWeight: 'bold',
    },
    standingsTable: {
      marginBottom: 10,
    },
    standingsHeaderRow: {
      flexDirection: 'row',
      paddingBottom: 8,
      borderBottomWidth: 2,
    },
    standingsHeaderPos: {
      width: 30,
      fontSize: 12,
      fontWeight: 'bold',
    },
    standingsHeaderName: {
      flex: 1,
      fontSize: 12,
      fontWeight: 'bold',
    },
    standingsHeaderStat: {
      width: 35,
      fontSize: 12,
      fontWeight: 'bold',
      textAlign: 'center',
    },
    standingsHeaderPts: {
      width: 40,
      fontSize: 12,
      fontWeight: 'bold',
      textAlign: 'center',
    },
    standingsRow: {
      flexDirection: 'row',
      paddingVertical: 10,
      borderBottomWidth: 1,
    },
    standingsPos: {
      width: 30,
      fontSize: 14,
    },
    standingsName: {
      flex: 1,
      fontSize: 14,
      fontWeight: '500',
    },
    standingsStat: {
      width: 35,
      fontSize: 14,
      textAlign: 'center',
    },
    standingsPts: {
      width: 40,
      fontSize: 14,
      fontWeight: 'bold',
      textAlign: 'center',
    },
    standingsLegend: {
      marginTop: 10,
    },
    standingsLegendText: {
      fontSize: 11,
      textAlign: 'center',
    },

    // Round Robin Matches
    roundRobinMatchesSection: {
      padding: 15,
    },
    matchGroupTitle: {
      fontSize: 16,
      fontWeight: '600',
      marginTop: 10,
      marginBottom: 10,
    },
    roundRobinMatchRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    roundRobinTeam: {
      flex: 1,
    },
    roundRobinTeamName: {
      fontSize: 16,
    },
    roundRobinScore: {
      flexDirection: 'row',
      alignItems: 'center',
      marginHorizontal: 15,
    },
    roundRobinScoreText: {
      fontSize: 20,
      fontWeight: 'bold',
      width: 30,
      textAlign: 'center',
    },
    roundRobinScoreDivider: {
      fontSize: 16,
      marginHorizontal: 5,
    },
    roundRobinVs: {
      fontSize: 14,
      marginHorizontal: 15,
    },
    drawBadge: {
      fontSize: 12,
      textAlign: 'center',
      marginTop: 5,
      fontStyle: 'italic',
    },

    // Elimination brackets
    bracketSection: {
      padding: 20,
    },
    bracketTitleContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      marginBottom: 15,
    },
    bracketTitle: {
      fontSize: 20,
      fontWeight: 'bold',
    },
    roundSection: {
      marginBottom: 20,
    },
    roundTitle: {
      fontSize: 16,
      fontWeight: '600',
      marginBottom: 10,
    },
    matchCard: {
      borderRadius: 8,
      padding: 15,
      marginBottom: 10,
      borderWidth: 2,
    },
    matchHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 10,
      paddingBottom: 10,
      borderBottomWidth: 1,
      borderBottomColor: '#eee',
    },
    matchTitle: {
      fontSize: 14,
      fontWeight: '600',
    },
    matchStatus: {
      fontSize: 12,
      textTransform: 'capitalize',
    },
    resetBanner: {
      backgroundColor: '#FF9500',
      padding: 8,
      borderRadius: 5,
      marginBottom: 10,
    },
    resetBannerText: {
      color: '#fff',
      fontWeight: 'bold',
      textAlign: 'center',
      fontSize: 12,
    },
    participantRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingVertical: 8,
    },
    participantName: {
      fontSize: 16,
    },
    score: {
      fontSize: 18,
      fontWeight: 'bold',
      minWidth: 30,
      textAlign: 'right',
    },
    winnerLabel: {
      marginTop: 10,
      fontSize: 14,
      fontWeight: '600',
      textAlign: 'center',
    },

    // Leaderboard
    leaderboardContent: {
      padding: 15,
    },
    leaderboardHeader: {
      padding: 15,
      marginBottom: 10,
    },
    leaderboardTitle: {
      fontSize: 24,
      fontWeight: 'bold',
      marginBottom: 5,
    },
    leaderboardSubtitle: {
      fontSize: 14,
    },
    leaderboardItem: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: 15,
      borderRadius: 10,
      marginBottom: 10,
      borderWidth: 1,
    },
    leaderboardPosition: {
      width: 50,
      alignItems: 'center',
    },
    positionText: {
      fontSize: 20,
      fontWeight: 'bold',
    },
    leaderboardInfo: {
      flex: 1,
      marginLeft: 10,
    },
    leaderboardName: {
      fontSize: 16,
      fontWeight: '600',
      marginBottom: 5,
    },
    leaderboardStats: {
      flexDirection: 'row',
      gap: 10,
    },
    statText: {
      fontSize: 12,
      fontWeight: '500',
    },
    championIcon: {
      marginLeft: 10,
    },

    // Modal
    modalOverlay: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    modalContent: {
      borderRadius: 12,
      padding: 20,
      width: '85%',
      maxWidth: 400,
    },
    modalTitle: {
      fontSize: 20,
      fontWeight: 'bold',
      marginBottom: 20,
      textAlign: 'center',
    },
    modalParticipant: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 15,
      paddingBottom: 15,
      borderBottomWidth: 1,
      borderBottomColor: '#eee',
    },
    modalParticipantName: {
      fontSize: 16,
      fontWeight: '600',
      flex: 1,
    },
    scoreInput: {
      borderWidth: 1,
      borderRadius: 8,
      padding: 10,
      width: 80,
      fontSize: 16,
      textAlign: 'center',
    },
    modalLabel: {
      fontSize: 14,
      marginTop: 10,
      marginBottom: 15,
      textAlign: 'center',
    },
    winnerButton: {
      padding: 15,
      borderRadius: 8,
      marginBottom: 10,
      alignItems: 'center',
    },
    winnerButtonText: {
      fontSize: 16,
      fontWeight: '600',
    },

    errorText: {
      textAlign: 'center',
      fontSize: 18,
    },

    exportButton: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 16,
      paddingVertical: 10,
      borderRadius: 8,
      gap: 6,
    },
    exportButtonText: {
      fontSize: 14,
      fontWeight: '600',
    },
    moreButton: {
      paddingHorizontal: 12,
      paddingVertical: 8,
      borderRadius: 8,
      borderWidth: 1,
    },
  });
